"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomOrDefaultViewName = void 0;
const getDefaultViewName_1 = require("./getDefaultViewName");
const getCustomOrDefaultViewName = (customViewName, viewPathUrl) => customViewName || (0, getDefaultViewName_1.getDefaultViewName)(viewPathUrl);
exports.getCustomOrDefaultViewName = getCustomOrDefaultViewName;
//# sourceMappingURL=getCustomOrDefaultViewName.js.map